import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

export const deficiencyEntityAction = async (onboardingId, emailAddress, spocEmailAddress, deficiencyDescription) => {
    try {
        const payload = {
            onboardingId: onboardingId || 0,
            emailAddress: emailAddress || "",
            spocEmailAddress: spocEmailAddress || "",
            deficiencyDescription: deficiencyDescription || "",
        };

        const response = await apiClient.put(ATP_API_URL.DEFICIENCY_ENTITY, payload);

        if (response?.status === 200) {
            if (response.data?.success === false) {
                return { success: false, message: response.data.message || "Failed to submit deficiency" };
            }
            return { success: true, message: response.data?.message || "Deficiency submitted successfully" };
        }

        return { success: false, message: "Failed to submit deficiency" };
    } catch (error) {
        console.error("❌ Error submitting deficiency:", error);
        return { success: false, message: error.message || "Failed to submit deficiency" };
    }
};
